import { render } from "./lms.vue?vue&type=template&id=0684bcb4"
import script from "./lms.vue?vue&type=script&lang=js"
export * from "./lms.vue?vue&type=script&lang=js"

import "./lms.vue?vue&type=style&index=0&id=0684bcb4&lang=css"

import exportComponent from "/home/ubuntu/stages_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__